<template>
  <q-layout view="Hhh lpr Fff">
    <q-layout-header>
      <q-toolbar>
        <q-toolbar-title>
          <slot name="toolbar-title"></slot>
        </q-toolbar-title>
      </q-toolbar>
      <slot name="header"></slot>
    </q-layout-header>
    <q-page-container>
      <slot></slot>
    </q-page-container>
    <q-layout-footer>
      <q-tabs align="center">
        <q-route-tab
          icon="today"
          to="/activities"
          exact
          slot="title"
          :label="$t('nav.activities')"
          v-if="moduleActive('activities')"
        />
        <q-route-tab
          icon="build"
          to="/quotes"
          exact
          slot="title"
          :label="$t('nav.quotes')"
          v-if="moduleActive('quotes')"
        />
        <q-route-tab
          icon="settings"
          to="/settings"
          exact
          slot="title"
          :label="$t('nav.settings')"
        />
      </q-tabs>
    </q-layout-footer>
  </q-layout>
</template>
<script>
import config from 'config'
export default {
  methods: {
    moduleActive (mod) {
      return config.modules.includes(mod)
    }
  }
}
</script>
